"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ELEMENTS_TYPES = void 0;
const ELEMENTS_TYPES = ['card', 'cardExpirationDate', 'cardNumber', 'cardVerificationCode', 'data', 'text'];
exports.ELEMENTS_TYPES = ELEMENTS_TYPES;
var InputMode;

(function (InputMode) {
  InputMode["DECIMAL"] = "decimal";
  InputMode["EMAIL"] = "email";
  InputMode["NONE"] = "none";
  InputMode["NUMERIC"] = "numeric";
  InputMode["SEARCH"] = "search";
  InputMode["TEL"] = "tel";
  InputMode["TEXT"] = "text";
  InputMode["URL"] = "url";
})(InputMode || (InputMode = {}));